/* SelectTrigger.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import { Inline, xcss } from '@atlaskit/primitives';
import Pressable from '@atlaskit/primitives/pressable';
import React, { forwardRef } from 'react';
import { mergeRefs } from '../../../mergeRefs';
import { TEST_IDS } from '../../../TestIds';
const buttonStyles = xcss({
  cursor: 'pointer',
  paddingInlineStart: 'space.150',
  paddingInlineEnd: 'space.050',
  paddingBlock: 'space.050',
  borderRadius: 'border.radius',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  color: 'color.text',
  backgroundColor: 'color.background.neutral',
  fontSize: '0.875rem',
  fontWeight: '400',
  ':hover': {
    backgroundColor: 'color.background.neutral.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.neutral.pressed'
  }
});
const selectedStyles = xcss({
  color: 'color.text.selected',
  backgroundColor: 'color.background.selected',
  ':hover': {
    backgroundColor: 'color.background.selected.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.selected.pressed'
  }
});
const flipIconStyles = xcss({
  transform: 'rotate(180deg)'
});
const SelectTriggerInternal = (_ref, ref) => {
  let {
    triggerProps,
    filterLabel,
    isSelected,
    isExpanded,
    numberOfSelections,
    firstSelectedOptionLabel,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement(Pressable, _extends({}, triggerProps, {
    ref: mergeRefs(ref, triggerProps.ref),
    onClick: onClick,
    "data-testId": TEST_IDS.FACET_DROPDOWN_TRIGGERS,
    xcss: [buttonStyles, isSelected && selectedStyles]
  }), /*#__PURE__*/React.createElement("span", null, firstSelectedOptionLabel || filterLabel, numberOfSelections > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, ', ', /*#__PURE__*/React.createElement("strong", null, "+".concat(numberOfSelections - 1)))), /*#__PURE__*/React.createElement(Inline, {
    xcss: isExpanded ? flipIconStyles : undefined,
    as: "span"
  }, /*#__PURE__*/React.createElement(ChevronDownIcon, {
    label: ""
  })));
};
export const SelectTrigger = /*#__PURE__*/forwardRef(SelectTriggerInternal);